import { Injectable, DOCUMENT, inject } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { CdsLangService, LangCode } from '@cds/ng-core/lang';
import { DateAdapter } from '@cds/ng-web-components/datepicker';

@Injectable({
  providedIn: 'root',
})
export class LanguageChangeService {
  lang = inject(CdsLangService);
  private _adapter = inject<DateAdapter<string> | null>(DateAdapter<string>, { optional: true });
  private _locale = 'en-GB';
  private document = inject<Document>(DOCUMENT);

  lanSubject = new BehaviorSubject<LangCode>('en');
  initLanNotice = new BehaviorSubject<LangCode>('en');

  constructor() {
    this.init();
  }

  private init() {
    const lang = localStorage.getItem('language');
    this.initLanNotice.next(lang || 'en');
    this.setLang(lang || 'en');
  }

  setLang(lang: LangCode) {
    this.lang.setCurrentLang(lang);
    this.lanSubject.next(lang);
    this.initLanNotice.next(lang);
    localStorage.setItem('language', lang);
    this.document.documentElement.setAttribute('lang', lang);

    if (lang === 'en') {
      this.en();
    } else {
      this.zh();
    }
  }

  zh() {
    this._locale = 'zh-HK';
    this._adapter?.setLocale(this._locale);
  }

  en() {
    this._locale = 'en-GB';
    this._adapter?.setLocale(this._locale);
  }
}
